import React, { PropTypes } from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import Card from './components/Card';
import StyleDecorator from './components/StyleDecorator';
import Notice from './components/Notice';
import RootPageLink from './components/links/RootPageBackLink';
import LandingPageLink from './components/links/LandingPageLink';
import translate from './locale/translate';
import SipgateFormHeaderLogo from './components/images/SipgateFormHeaderLogo';
import VARIANTS from './utils/variants';

const mapStateToProps = (state, ownProps) => ({
	variant: ownProps.location.query.variant,
});

const RequestPasswordResetSuccessApp = (props) => {
	const footerLink = props.variant === VARIANTS.TEAM
		? <RootPageLink />
		: <LandingPageLink />;
	return (
		<Card
			header={<SipgateFormHeaderLogo />}
			footer={footerLink}
		>
			<Notice>
				<h3>{translate('NOTICE_PASSWORD_REQUEST_SENT_HEADER')}</h3>
				<p>{translate('NOTICE_PASSWORD_REQUEST_SENT')}</p>
			</Notice>
		</Card>
	);
};

RequestPasswordResetSuccessApp.propTypes = {
	variant: PropTypes.string,
};

export default connect(mapStateToProps)(StyleDecorator(Radium(RequestPasswordResetSuccessApp)));



// WEBPACK FOOTER //
// ./src/RequestPasswordResetSuccessApp.js